export default __webpack_public_path__ + "static/fabian-17a23a8c9faa054bc7aecf59fd184545.jpg";